//
// This well-known symbol approach is similar to how the core language now handles internal slots for types
// to match internal interfaces. Think of everything in this file as internal ADC symbols
// that mean something special only in our applications, in the same way that Symbol.iterator means
// something to the core language.
//
// How exactly these symbols are used, or what information they reference, is left as an implementation detail
// dependent upon the context and requirements.
//
export const GRAPH_API_FRAGMENT_DEFINITION: unique symbol = Symbol(
  '$$resi.graph_fragment_definition'
)
export const GRAPH_API_FRAGMENT_REFERENCE: unique symbol = Symbol(
  '$$resi.graph_fragment_reference'
)
